import React, { useEffect } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";
import { useMutation } from "react-query";
import { FaExclamationCircle } from "react-icons/fa";
import axios from "axios";
import { authState } from "../recoil";
import { useSetRecoilState } from "recoil";
import { Label } from "../components/Label";
import { Input } from "../components/Input";
import { Button } from "../components/Button";
import { useNavigate } from "react-router-dom";

export const Login: React.FC = () => {
  const setToken = useSetRecoilState(authState);
  const navigate = useNavigate();

  const { mutate, isError, isLoading, data } = useMutation(
    async (data: any) => {
      return await axios.post("/admin/login", data);
    }
  );

  const formik = useFormik({
    initialValues: {
      email: "",
      password: "",
    },
    validationSchema: Yup.object({
      email: Yup.string().required("Required"),
      password: Yup.string()
        .min(6, "Should be 8 Numbers or characters")
        .required("Required"),
    }),
    onSubmit: async (values) => {
      mutate(values);
      try {
      } catch (error) {
        console.log(error);
      }
    },
  });

  useEffect(() => {
    if (data) {
      setToken({
        token: data.data?.token,
        role: data.data?.user?.role,
        restaurantId: data.data?.user?.restaurantId || null,
        branchId: data.data?.user?.branchId || null,
      });
      localStorage.setItem("token", data.data.token);
      if (localStorage.getItem("token")) {
        axios.defaults.headers.common["Authorization"] =
          "Bearer " + data.data?.token;
      }
      if (data.data?.user?.role === "restaurantAdmin") {
        navigate("/cashiers");
      } else if (data.data?.user?.role === "admin") {
        navigate("/home");
      }
    }
  }, [data, navigate, setToken]);

  return (
    <div className="flex justify-center pt-20">
      <form
        className="flex w-96 flex-col gap-4 rounded-lg border border-slate-300 p-8 shadow-sm"
        onSubmit={formik.handleSubmit}
      >
        <>
          <img src="/splash-logo.png" alt="specter logo" />

          {isError && (
            <p
              dir="ltr"
              className="flex justify-start items-center gap-2 rounded-md bg-red-500 p-2 text-white"
            >
              <FaExclamationCircle />
              Invalid Email or Password
            </p>
          )}
          <div className="w-full">
            <Label className="text-left" htmlFor="email">
              Email
            </Label>
            <Input
              type="email"
              id="email"
              className="w-full"
              {...formik.getFieldProps("email")}
              error={formik.touched.email ? formik.errors.email : ""}
            />
          </div>
          <div className="w-full">
            <Label className="text-left" htmlFor="password">
              Password
            </Label>
            <Input
              type="password"
              id="password"
              className="w-full"
              {...formik.getFieldProps("password")}
              error={formik.touched.password ? formik.errors.password : ""}
            />
          </div>
          <Button green type="submit" loading={isLoading}>
            Login
          </Button>
        </>
      </form>
    </div>
  );
};
